// extracted by mini-css-extract-plugin
export default {"skeleton-chips-group":"kC1uy","skeleton-chips-group_wrap":"jsTR3"};